function k(e) {
  const t = Object.prototype.toString;
  if (t.call(e) !== "[object String]" && t.call(e) !== "[object Object]")
    return !1;
  if (t.call(e) === "[object Object]") {
    const r = Object.prototype.hasOwnProperty;
    let a = !1;
    for (const n in e)
      if (r.call(e, n)) {
        a = !0;
        break;
      }
    if (!a)
      return !1;
    const c = (n, l, s) => r.call(n, l) && t.call(n[l]) !== "[object " + s + "]";
    if (c(e, "name", "String") || c(e, "path", "String") || c(e, "hash", "String"))
      return !1;
    if (r.call(e, "query")) {
      const n = e.query;
      if (n && t.call(n) === "[object Object]") {
        let l = !0;
        for (const s in n)
          if (r.call(n, s)) {
            const o = n[s], b = Array.isArray(o) ? o.every((u) => u === null || t.call(u) === "[object String]") : !0;
            if (t.call(o) !== "[object String]" && !b && o !== null && o !== void 0) {
              l = !1;
              break;
            }
          }
        if (!l)
          return !1;
      } else
        return !1;
    }
    if (r.call(e, "params") && e.params && t.call(e.params) !== "[object Object]" || c(e, "append", "Boolean") || c(e, "replace", "Boolean"))
      return !1;
  }
  return !0;
}
const i = (e, t) => {
  if (Object.prototype.toString.call(t) === "[object String]" && t.length) {
    const r = t[0].toUpperCase() + t.slice(1);
    return Object.prototype.toString.call(e) === `[object ${r}]`;
  }
  return !1;
}, g = (e) => `self.onmessage = event => { const args = event.data; if (args) { (${e}).call(null, self, args) } }`, j = (e, t) => {
  if (typeof t < "u" && "Worker" in t && ("URL" in t || "webkitURL" in t) && ((t.Worker || Worker) ?? !1) !== !1) {
    const c = t.URL || t.webkitURL, n = g(e), l = new Blob([n], { type: "application/javascript" }), s = c.createObjectURL(l);
    return new Worker(s);
  }
};
j(function(e, t) {
  const r = new FileReader();
  r.readAsDataURL(t), r.onload = ({ target: { result: a } }) => {
    e.postMessage(a);
  };
}, window);
const f = (e) => {
  if (i(e, "date"))
    return !0;
  if (i(e, "string")) {
    const t = e.split("-");
    if (t.length === 3) {
      const r = parseInt(t[0], 10), a = parseInt(t[1], 10), c = parseInt(t[2], 10);
      if (r && a && c && new Date(r, a, c).toString() !== "Invalid Date")
        return !0;
    }
  }
  return !1;
}, y = (e) => e ? i(e, "array") ? e.every((t) => f(t)) : e && i(e, "object") ? "to" in e && f(e.to) && "from" in e && f(e.from) : !1 : !0;
export {
  k as R,
  i as a,
  y as c
};
